import React from "react";

//Librerias
import { Link, useLocation } from "react-router-dom";

//Componentes de Material UI
import { List,  ListItemIcon, ListItemText, ListItemButton } from "@mui/material";

//Iconos de Material UI
import {
    Home as HomeIcon,
    EmojiEvents as TrophyIcon,
} from "@mui/icons-material";

const ListMenuUser = ({ toggleDrawer }) => {
    //===============================================================================================================================================
    //========================================== Hooks personalizados ===============================================================================
    //===============================================================================================================================================
    const location = useLocation();
    //===============================================================================================================================================
    //========================================== useEffects =========================================================================================
    //===============================================================================================================================================

    //===============================================================================================================================================
    //========================================== Renders ============================================================================================
    //===============================================================================================================================================
    return (
        <List component="nav">
            <ListItemButton
                button
                component={Link}
                to="/wilson/servicio"
                selected={
                    location.pathname === "/wilson/servicio" ||
                    location.pathname === "/wilson/servicio/"
                }
                onClick={(e) => toggleDrawer(e, false)}
            >
                <ListItemIcon>
                    <HomeIcon sx={{color:"#fff"}} />
                </ListItemIcon>
                <ListItemText sx={{color:"#fff"}} primary="Servicios" />
            </ListItemButton>
            <ListItemButton
                button
                component={Link}
                to="/wilson/sala-de-trofeos"
                selected={
                    location.pathname === "/wilson/sala-de-trofeos" ||
                    location.pathname === "/wilson/sala-de-trofeos/"
                }
                onClick={(e) => toggleDrawer(e, false)}
            >
                <ListItemIcon>
                    <TrophyIcon sx={{color:"#FFD700"}} />
                </ListItemIcon>
                <ListItemText sx={{color:"#fff"}} primary="Reconocimientos de la confianza" />
            </ListItemButton>
        </List>
    );
};

export default ListMenuUser;
